import { For, createMemo, createSignal } from 'solid-js';
import type { ProjectManifest } from '../types/project';
import { projectDisplayTitle } from '../types/project';
import { DesktopIcon } from './DesktopIcon';

interface DesktopProps {
  projects: ProjectManifest[];
  openProjects: () => void;
  openAbout: () => void;
  openStory: () => void;
  openSocial: () => void;
  openRecycleBin: () => void;
  openProject: (project: ProjectManifest) => void;
}

export function Desktop(props: DesktopProps) {
  const [selected, setSelected] = createSignal<string>();
  const featured = createMemo(() => props.projects.filter((project) => project.featured && project.status === 'published').slice(0, 3));

  return (
    <main class="desktop" onClick={() => setSelected(undefined)}>
      <div class="desktop-watermark" aria-hidden="true">
        <strong>IVAN SIVÁK</strong>
        <span>PERSONAL WORKSTATION</span>
      </div>

      <div class="desktop-icons" role="list" aria-label="Desktop shortcuts">
        <DesktopIcon
          id="projects"
          label="My Projects"
          icon="folder"
          selected={selected() === 'projects'}
          onSelect={setSelected}
          onOpen={props.openProjects}
        />
        <DesktopIcon
          id="about"
          label="About Ivan"
          icon="info"
          selected={selected() === 'about'}
          onSelect={setSelected}
          onOpen={props.openAbout}
        />
        <DesktopIcon
          id="story"
          label="My Story"
          icon="document"
          selected={selected() === 'story'}
          onSelect={setSelected}
          onOpen={props.openStory}
        />
        <DesktopIcon
          id="network"
          label="Network Neighborhood"
          icon="network"
          selected={selected() === 'network'}
          onSelect={setSelected}
          onOpen={props.openSocial}
        />
        <For each={featured()}>
          {(project) => (
            <DesktopIcon
              id={`project:${project.slug}`}
              label={projectDisplayTitle(project)}
              icon="project"
              project={project}
              selected={selected() === `project:${project.slug}`}
              onSelect={setSelected}
              onOpen={() => props.openProject(project)}
            />
          )}
        </For>
        <DesktopIcon
          id="recycle"
          label="Recycle Bin"
          icon="recycle"
          selected={selected() === 'recycle'}
          onSelect={setSelected}
          onOpen={props.openRecycleBin}
        />
      </div>
    </main>
  );
}
